import { authComponents_svSE } from "@ssf/auth-components";
import { components_svSE } from "@ssf/components";
import i18next, { use } from "i18next";
import { initReactI18next } from "react-i18next";

import portalWeb_svSE from "../locales/locale.sv-SE.json";

const svSE = {
  ...components_svSE,
  ...authComponents_svSE,
  ...portalWeb_svSE,
};

use(initReactI18next).init({
  lng: "svSE",
  fallbackLng: "svSE",
  defaultNS: "common",
  resources: { svSE },
  react: {
    useSuspense: true,
  },
});

export { i18next };
